module.exports = __webpack_public_path__ + "img/让爱回家.95161273.png";